module.exports = __webpack_public_path__ + "img/webcam.79a20b90.png";